
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestromong-chennai/pre-chennai",
      function () {
        return require("private-next-pages/prestromong-chennai/pre-chennai.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prestromong-chennai/pre-chennai"])
      });
    }
  